/*
 * EDITING THIS?
 * Please clean up UNSAFE_componentWillReceiveProps!
 * See: https://github.com/Tettra/tettra-wiki/issues/6002
 */

import $ from 'jquery';
import React, { Fragment } from 'react';
import SidebarItems from './SidebarItems';
import MoveSubcategoryWrapper from '../move/MoveSubcategoryWrapper';
import CreateSubcategoryWrapper from '../create/CreateSubcategoryWrapper';
import {
    getCategoryUrl,
    getApiCategoryUrl,
    getCreateDraftUrlFromCategoryId,
} from '../../utilities/urlHelper';
import {
    canCreateQuestion,
    canCreatePage,
    canEditCategory,
} from '../../utilities/permissionsUtilities';
import CreateOrEditCategoryWrapper from '../create/CreateOrEditCategoryWrapper';

const getActiveCategoryId = () => {
    if (window.categoryId) {
        return window.categoryId;
    } if (window._tettraDraft) {
        return window._tettraDraft.category_id;
    }
    return null;
};

class CategorySidebarItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getState(props);
    }

    /*
     * EDITING THIS?
     * Please clean up UNSAFE_componentWillReceiveProps!
     * See: https://github.com/Tettra/tettra-wiki/issues/6002
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { category, categoryItems, open: wasOpen } = this.state;
        const activeCategoryId = getActiveCategoryId();
        const open = wasOpen || ((window.pageId || window.suggestionId || window.folderId || window.draftId) && activeCategoryId === category.id);

        if (open && !categoryItems) {
            $.get(getApiCategoryUrl(category.id)).then(({ categoryItems }) => this.setState({ categoryItems }));
        }

        return this.setState({ open });
    }

    getState = (props) => {
        const { category } = props;
        const activeCategoryId = getActiveCategoryId();
        const open = (window.pageId || window.suggestionId || window.folderId || window.draftId) && activeCategoryId === category.id;
        const categoryItems = null;

        if (open) {
            $.get(getApiCategoryUrl(category.id)).then(({ categoryItems }) => this.setState({ categoryItems }));
        }

        return { category, open, categoryItems };
    };

    toggleCategory = () => {
        let { open, categoryItems, category: { id } } = this.state;

        if (!open && categoryItems == null) {
            $.get(getApiCategoryUrl(id)).then(({ categoryItems }) => this.setState({ categoryItems }));
        }

        open = !open;

        return this.setState({ open });
    };

    render() {
        const { open, category, categoryItems } = this.state;
        const {
            id, name, icon, color,
        } = category;
        const categorySelectedClass = (window.categoryId === category.id) && !(window.pageId || window.folderId) ? 'left-nav__selected' : '';

        const hasCategoryActions = canCreatePage() || canEditCategory();

        return (
            <div className="left-nav__category-container break-word">
                <div className={`left-nav__item left-nav__category ${categorySelectedClass}`}>
                    <span className="expand-caret" onMouseDown={this.toggleCategory}>{ open ? '⌄' : '›' }</span>
                    <img className="left-nav__icon" height="22" width="22" src={icon} style={{ backgroundColor: `#${color}` }} />
                    <a className="left-nav__text" href={getCategoryUrl(id)}>
                        {name}
                    </a>
                    <div className="dropdown dropdown-right-aligned flex-none">
                        {hasCategoryActions
                                && (
                                    <Fragment>
                                        <button className="left-nav__menu dropdown-link" type="button">
                                            <img className="button-icon" height="16" width="4" src="/img/icons/dropdown-elipsis.svg" alt="dropdown menu" />
                                        </button>

                                        <div className="dropdown-overlay" style={{ display: 'none' }} />
                                        <div className="dropdown-content no-select" style={{ display: 'none' }}>
                                            {canEditCategory()
                                            && (
                                                <CreateOrEditCategoryWrapper category_id={id}>
                                                    <span className="dropdown-option link">Edit</span>
                                                </CreateOrEditCategoryWrapper>
                                            )}
                                            {canEditCategory() && <MoveSubcategoryWrapper subcategory={category} />}
                                            {canCreateQuestion()
                                            && <span className="link dropdown-option category-new-question-link" data-category-id={id}>New question</span>}
                                            {canCreatePage()
                                            && <a className="dropdown-option" href={getCreateDraftUrlFromCategoryId(id)}>New page</a>}
                                            {canEditCategory()
                                            && (
                                                <CreateSubcategoryWrapper
                                                    categoryId={id}
                                                    parentName={name}
                                                    isSidebar
                                                />
                                            )}
                                            <a className="dropdown-option do-cancel">Cancel</a>
                                        </div>
                                    </Fragment>
                                )}
                    </div>
                </div>
                {open && (categoryItems == null)
                        && <div className="left-nav__loading loading">Loading category</div>}
                {open && categoryItems && (categoryItems.length > 0
                    ? <div className="category-pages"><SidebarItems categoryItems={categoryItems} pageId={window.pageId} /></div>
                    : <div className="left-nav__loading">No items</div>)}
            </div>
        );
    }
}

export default CategorySidebarItem;
